import { render, staticRenderFns } from "./common-demoUrl.vue?vue&type=template&id=52d88973&scoped=true"
import script from "./common-demoUrl.vue?vue&type=script&lang=js"
export * from "./common-demoUrl.vue?vue&type=script&lang=js"
import style0 from "./common-demoUrl.vue?vue&type=style&index=0&id=52d88973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d88973",
  null
  
)

export default component.exports